import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import SimpleMDE from 'react-simplemde-editor'
import arraySort from 'array-sort'
import { FormattedMessage } from 'react-intl'
import firstBy from 'thenby'

import MarkdownLabel from '../../mini/MarkdownLabel'
import SearchArea from '../../mini/SearchArea'
import Indicator from '../readability/Indicator'
import JustForMentors from '../basicinformation/JustForMentors'
import NotYetSpecified from '../../mini/NotYetSpecified'
import LevelSelect from '../../mini/LevelSelect'
import CourseSelect from '../../mini/CourseSelect'
import { HelperText } from '../_Styled'
import ErrorText from '../../typography/ErrorText'
import QuestTypeIcon from '../../mini/QuestTypeIcon'

import {
  italicsOnlyMDEOptions,
  simpleMDEOptions
} from '../../../utils/markdowneditor'
import {
  findQuestMentorNote,
  getQuestEditors,
  basicInfoHasJustForMentors
} from '../../../utils/quest'
import {
  hasReadabilityStats,
  getSectionScores
} from '../../../utils/readability'
import {
  title,
  authors,
  descriptionMessage,
  // yes,
  // no,
  primarySubject,
  targetGradeLevel,
  questGoal
} from '../../../utils/messages'
import { messages } from '../../../utils/messages/placeholder'
import { getActiveQdUsers, questManagers } from '../../../selectors/users'
import { alphabeticalSubjects } from '../../../selectors/subjects'
import { combineQuestUsersWithRoleUsers } from '../../../utils/users'
import { parseErrors, hasExpectedError } from '../../../utils/error'
import { getTruncatedString } from '../../../utils/string'

class BasicInformation extends Component {
  constructor(props) {
    super(props)
    this.state = {
      mentorNoteExists: Boolean(findQuestMentorNote(props.notes)),
      questType: props.quest.type.id,
      intendedCourse: props.quest.mock_course
        ? this.formatCourse(props.quest.mock_course)
        : null,
      intendedLevel: props.quest.mock_level
        ? this.formatLevel(props.quest.mock_level)
        : null
    }

    this.handleChangeBound = this.handleChange.bind(this)
    this.handleDescriptionChangeBound = this.handleDescriptionChange.bind(this)
    this.handleMentorNoteChangeBound = this.handleMentorNoteChange.bind(this)
    this.onMentorFileUploadBound = this.onMentorFileUpload.bind(this)
    this.handleMentorFileDescriptionChangeBound =
      this.handleMentorFileDescriptionChange.bind(this)
    this.onDeleteQuestMentorNoteClickBound =
      this.onDeleteQuestMentorNoteClick.bind(this)
    this.handleAuthorChangeBound = this.handleAuthorChange.bind(this)
    this.handleSubjectChangeBound = this.handleSubjectChange.bind(this)
    this.handleGroupQuestToggleBound = this.handleGroupQuestToggle.bind(this)
    this.handleGradeLevelChangeBound = this.handleGradeLevelChange.bind(this)
    this.onIntendedCourseChangeBound = this.onIntendedCourseChange.bind(this)
    this.onIntendedLevelChangeBound = this.onIntendedLevelChange.bind(this)
    this.handleManagerChangeBound = this.handleManagerChange.bind(this)
    this.handleDrivingQuestionChangeBound =
      this.handleDrivingQuestionChange.bind(this)
    this.handleQuestGoalChangeBound = this.handleQuestGoalChange.bind(this)
    this.handleContentWarningsChange =
      this.handleContentWarningsChange.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.isEditingQuest && nextProps.isEditingQuest) {
      this.setState(() => ({
        questType: nextProps.quest.type.id
      }))
    }
  }

  render() {
    const {
      quest,
      notes,
      isEditingQuest,
      subjects,
      gradeLevels,
      dispatch,
      qdUsers,
      error,
      mockCourses,
      questManagerUsers
    } = this.props

    const { intendedCourse, intendedLevel } = this.state
    const questMentorNote = findQuestMentorNote(notes)

    const descriptionOptions = Object.assign({}, simpleMDEOptions)
    descriptionOptions.initialValue = quest.description
    descriptionOptions.placeholder = ''
    descriptionOptions.autofocus = false

    const drivingQuestionOptions = Object.assign({}, italicsOnlyMDEOptions)
    drivingQuestionOptions.initialValue = quest.driving_question
    drivingQuestionOptions.placeholder = ''
    drivingQuestionOptions.autofocus = false

    const questGoalOptions = Object.assign({}, italicsOnlyMDEOptions)
    questGoalOptions.initialValue = quest.learner_goal
    questGoalOptions.placeholder = ''
    questGoalOptions.autofocus = false

    const questEditors = getQuestEditors(quest).map(editor => editor.name)
    const authorsAndQdUsers = combineQuestUsersWithRoleUsers(
      quest.authors,
      qdUsers
    )
    const questManagersAndQuestManagerUsers = combineQuestUsersWithRoleUsers(
      quest.managers,
      questManagerUsers
    )
    const orgHasQuestManagers = questManagersAndQuestManagerUsers.length > 0

    return (
      <div className="basic-information">
        <div className="section-inner">
          {isEditingQuest && (
            <div className="edit-fields">
              <div className="title">
                {title}
                <div className="requiredtool" />
              </div>
              <input
                type="text"
                id="name"
                defaultValue={quest.name}
                className="form-control"
                onChange={this.handleChangeBound}
              />
              {error &&
                hasExpectedError(error, 'name', 'has already been taken') && (
                  <ErrorText style={{ marginTop: '3px' }}>
                    Sorry, that quest title is in use. Please choose a different
                    title.
                  </ErrorText>
                )}
            </div>
          )}

          {isEditingQuest &&
            (orgHasQuestManagers ? (
              <div className="org-has-quest-managers">
                <div className="title-edit-fields">
                  <div className="title">
                    {authors}
                    <div className="requiredtool" />
                  </div>
                  <div className="edit-fields">
                    <SearchArea
                      dispatch={dispatch}
                      label=""
                      area={`author${
                        orgHasQuestManagers ? '-with-managers' : ''
                      }`}
                      placeholder={this.context.intl.formatMessage(
                        messages.selectAuthors
                      )}
                      values={quest.author_ids}
                      options={arraySort(this.mapList(authorsAndQdUsers), [
                        'sort'
                      ])}
                      handleChange={this.handleAuthorChangeBound}
                      authorEdit
                    />
                  </div>
                </div>
                <div className="title-edit-fields">
                  <div className="title">Quest Manager</div>
                  <div className="edit-fields">
                    <SearchArea
                      dispatch={dispatch}
                      label=""
                      area="managers"
                      placeholder=""
                      values={
                        quest.managers.length > 0 ? quest.managers[0].id : null
                      }
                      options={arraySort(
                        this.mapList(questManagersAndQuestManagerUsers),
                        ['sort']
                      )}
                      handleChange={this.handleManagerChangeBound}
                      single
                    />
                  </div>
                </div>
              </div>
            ) : (
              <React.Fragment>
                <div className="title">
                  {authors}
                  <div className="requiredtool" />
                </div>
                <div className="edit-fields">
                  <SearchArea
                    dispatch={dispatch}
                    label=""
                    area={`author${
                      orgHasQuestManagers ? '-with-managers' : ''
                    }`}
                    placeholder={this.context.intl.formatMessage(
                      messages.selectAuthors
                    )}
                    values={quest.author_ids}
                    options={arraySort(this.mapList(authorsAndQdUsers), [
                      'sort'
                    ])}
                    handleChange={this.handleAuthorChangeBound}
                    authorEdit
                  />
                </div>
              </React.Fragment>
            ))}
          {!isEditingQuest && (
            <React.Fragment>
              <div className="title">
                {authors}
                <div className="requiredtool" />
              </div>
              <div className="view-fields">
                <label id="view-authors">{quest.author}</label>
              </div>
              <div className="title">Quest Manager</div>
              <div className="view-fields">
                {quest.managers.length > 0 ? (
                  <label id="view-managers">
                    {quest.managers[0].display_name}
                  </label>
                ) : (
                  <NotYetSpecified />
                )}
              </div>
            </React.Fragment>
          )}

          <div className="title">
            <FormattedMessage
              id={'Quest.BasicInfo.Editors'}
              defaultMessage={'Editors'}
            />
          </div>
          <div className="view-fields">
            {questEditors.length > 0 ? (
              <label id="view-editors">
                {arraySort(questEditors, ['display_name']).join(', ')}
              </label>
            ) : (
              <NotYetSpecified />
            )}
          </div>

          <div className="title">
            Type
            <div className="requiredtool" />
          </div>
          {isEditingQuest && (
            <div className="edit-fields" id="questTypes">
              {this.props.questTypes.map(qt => {
                return (
                  <li>
                    <label>
                      <input
                        type="radio"
                        id="quest_type_id"
                        checked={this.state.questType === qt.id}
                        value={qt.id}
                        onClick={this.handleChangeBound}
                      />
                      <QuestTypeIcon
                        key={`quest-type-icon-${qt.id}`}
                        id={qt.id}
                      />
                      {qt.name}
                    </label>
                  </li>
                )
              })}
            </div>
          )}
          {!isEditingQuest && (
            <div className="view-fields">
              {quest.type.name ? (
                <label>{quest.type.name}</label>
              ) : (
                <NotYetSpecified />
              )}
            </div>
          )}

          <div className="title">
            <FormattedMessage
              id={'Quest.BasicInfo.DrivingQuestion'}
              defaultMessage={'Driving Question'}
            />
            <div className="requiredtool" />
          </div>
          {isEditingQuest && (
            <div className="edit-fields" id="driving_question">
              <SimpleMDE
                options={drivingQuestionOptions}
                onChange={this.handleDrivingQuestionChangeBound}
              />
              {error &&
              hasExpectedError(error, 'driving_question', 'length error') ? (
                <ErrorText style={{ marginTop: '3px' }}>
                  Maximum 255 characters
                </ErrorText>
              ) : (
                <HelperText>Maximum 255 characters</HelperText>
              )}
            </div>
          )}
          {!isEditingQuest && (
            <div className="view-fields">
              <MarkdownLabel
                id="view-driving_question"
                value={quest.driving_question}
              />
              {hasReadabilityStats(quest, 'driving_question') && (
                <Indicator
                  quest={quest}
                  section={'quest'}
                  subsection={'driving_question'}
                  dispatch={dispatch}
                  scores={getSectionScores(quest, 'driving_question')}
                  readableStatsObject={quest}
                />
              )}
            </div>
          )}

          <div className="title">{questGoal}</div>
          {isEditingQuest && (
            <div className="edit-fields" id="learner_goal">
              <SimpleMDE
                options={questGoalOptions}
                onChange={this.handleQuestGoalChangeBound}
              />
              {error &&
              hasExpectedError(error, 'learner_goal', 'length error') ? (
                <ErrorText style={{ marginTop: '3px' }}>
                  Maximum 255 characters
                </ErrorText>
              ) : (
                <HelperText>Maximum 255 characters</HelperText>
              )}
            </div>
          )}
          {!isEditingQuest && (
            <div className="view-fields">
              <MarkdownLabel id="view-quest_goal" value={quest.learner_goal} />
            </div>
          )}

          <div className="title">
            {descriptionMessage}
            <div className="requiredtool" />
          </div>

          {isEditingQuest && (
            <div className="edit-fields" id="description">
              <SimpleMDE
                options={descriptionOptions}
                onChange={this.handleDescriptionChangeBound}
              />
            </div>
          )}
          {!isEditingQuest && (
            <div className="view-fields">
              <MarkdownLabel id="view-description" value={quest.description} />
              {hasReadabilityStats(quest, 'description') && (
                <Indicator
                  quest={quest}
                  section={'quest'}
                  subsection={'description'}
                  dispatch={dispatch}
                  scores={getSectionScores(quest, 'description')}
                  readableStatsObject={quest}
                />
              )}
            </div>
          )}

          {isEditingQuest ? (
            <div className="intended-course-level-container edit-fields">
              <div className="intended-course-container">
                <div
                  className={`title ${
                    mockCourses.length < 1 ? 'disabled' : ''
                  }`}
                >
                  Intended Journey
                </div>
                <CourseSelect
                  course={intendedCourse}
                  courses={mockCourses}
                  onCourseChange={this.onIntendedCourseChangeBound}
                  disabled={mockCourses.length < 1}
                  labelTruncationLength={39}
                />
              </div>
              <div className="intended-level-container">
                <div
                  className={`title ${
                    !intendedCourse ||
                    (intendedCourse &&
                      this.getCourseLevels(intendedCourse).length === 0)
                      ? 'disabled'
                      : ''
                  }`}
                >
                  Intended Level
                </div>
                <LevelSelect
                  level={intendedLevel}
                  levels={
                    intendedCourse ? this.getCourseLevels(intendedCourse) : []
                  }
                  onLevelChange={this.onIntendedLevelChangeBound}
                  noMockCourses={mockCourses.length === 0}
                  intendedCourseHasNoLevels={
                    intendedCourse &&
                    this.getCourseLevels(intendedCourse).length === 0
                  }
                  course={intendedCourse}
                />
              </div>
            </div>
          ) : (
            <React.Fragment>
              <div className="title">Intended Journey / Level</div>
              <div className="view-fields">
                {quest.mock_course ? (
                  <label className="intended-course">
                    {quest.mock_course.name}
                    <span> / </span>
                    {quest.mock_level
                      ? `${
                          quest.mock_level.mastery
                            ? 'Mastery Level'
                            : 'Level ' + quest.mock_level.number
                        }: ${quest.mock_level.name}`
                      : 'Level: Not Yet Specified'}
                  </label>
                ) : (
                  <NotYetSpecified />
                )}
              </div>
            </React.Fragment>
          )}

          <div className="title">{primarySubject}</div>
          {isEditingQuest && (
            <div className="edit-fields primary-subject">
              <SearchArea
                dispatch={this.props.dispatch}
                label=""
                placeholder=""
                area="subject"
                values={quest.subject.id}
                options={subjects.map(s => {
                  return { label: s.name, value: s.id }
                })}
                handleChange={this.handleSubjectChangeBound}
                single
              />
            </div>
          )}
          {!isEditingQuest && (
            <div className="view-fields">
              {quest.subject.name ? (
                <label>{quest.subject.name}</label>
              ) : (
                <NotYetSpecified />
              )}
            </div>
          )}

          <div className="title">{targetGradeLevel}</div>
          {isEditingQuest && (
            <div className="edit-fields">
              <SearchArea
                dispatch={this.props.dispatch}
                label=""
                placeholder=""
                area="gradelevel"
                values={quest.grade_levels.map(gl => gl.id)}
                options={arraySort(this.formatGradeLevels(gradeLevels), [
                  'sort'
                ])}
                handleChange={this.handleGradeLevelChangeBound}
              />
            </div>
          )}
          {!isEditingQuest && (
            <div className="view-fields">
              {quest.grade_levels.length > 0 ? (
                <label>
                  {quest.grade_levels
                    .sort(firstBy('sort_order'))
                    .map(gradeLevel => gradeLevel.name)
                    .join(', ')}
                </label>
              ) : (
                <NotYetSpecified />
              )}
            </div>
          )}

          {/* <div className='title'>
            <FormattedMessage id={'Quest.BasicInfo.GroupQuest'}
              defaultMessage={'Group Quest?'}
            />
          </div>
          {!isEditingQuest &&
            <div className='view-fields'>
              <label>{quest.designed_for_groups ? yes : no}</label>
            </div>
          }
          {isEditingQuest &&
            <div className='edit-fields padded' id='groupQuest'>
              <li>
                <label htmlFor='group_quest'>
                  <input type='radio' id='designed_for_groups' name='designedForGroups' className='form-control'
                    defaultChecked={quest.designed_for_groups}
                    value={true} onChange={this.handleGroupQuestToggleBound}
                  />
                  {yes}
                </label>
              </li>
              <li>
                <label htmlFor='group_quest'>
                  <input type='radio' id='designed_for_groups' name='designedForGroups' className='form-control'
                    defaultChecked={!quest.designed_for_groups}
                    value={false} onChange={this.handleGroupQuestToggleBound}
                  />
                  {no}
                </label>
              </li>
            </div>
          } */}
          {(basicInfoHasJustForMentors(quest, questMentorNote) ||
            isEditingQuest) && (
            <JustForMentors
              quest={quest}
              questMentorNote={questMentorNote}
              isUploadingNote={this.props.isUploadingNote}
              isDeletingNote={this.props.isDeletingNote}
              handleMentorNoteChange={this.handleMentorNoteChangeBound}
              onMentorFileUpload={this.onMentorFileUploadBound}
              handleMentorFileDescriptionChange={
                this.handleMentorFileDescriptionChangeBound
              }
              onDeleteQuestMentorNoteClick={
                this.onDeleteQuestMentorNoteClickBound
              }
              handleChange={this.handleChangeBound}
              isEditing={isEditingQuest}
              mentorNoteExists={this.state.mentorNoteExists}
              handleContentWarningsChange={this.handleContentWarningsChange}
              error={error}
            />
          )}
        </div>
      </div>
    )
  }

  handleChange(e) {
    if (e.target.id === 'quest_type_id') {
      const value = parseInt(e.target.value)
      this.setState(() => ({ questType: value }))
    }

    this.props.handleChange(e)
  }

  handleDescriptionChange(e) {
    // Hacky way to format the event id and value so parent's edit function works
    // The markdown editor makes this trickier than with a standard textfield
    let event = {
      target: {}
    }
    event.target.id = 'description'
    event.target.value = e
    this.props.handleChange(event)
  }

  handleDrivingQuestionChange(e) {
    // Hacky way to format the event id and value so parent's edit function works
    // The markdown editor makes this trickier than with a standard textfield
    let event = {
      target: {}
    }
    event.target.id = 'driving_question'
    event.target.value = e
    this.props.handleChange(event)
  }

  handleQuestGoalChange(e) {
    // Hacky way to format the event id and value so parent's edit function works
    // The markdown editor makes this trickier than with a standard textfield
    let event = {
      target: {}
    }
    event.target.id = 'learner_goal'
    event.target.value = e
    this.props.handleChange(event)
  }

  handleMentorNoteChange(e) {
    // Hacky way to format the event id and value so parent's edit function works
    // The markdown editor makes this trickier than with a standard textfield
    let event = {
      target: {}
    }
    event.target.id = 'inline_mentor_notes'
    event.target.value = e
    this.props.handleChange(event)
  }

  onMentorFileUpload(e) {
    if (e.target.files.length > 0) {
      this.setState(state => ({ mentorNoteExists: true }))
      this.props.handleNotesUpload(e.target.files[0])
    } else {
      this.setState(state => ({ mentorNoteExists: false }))
      this.props.handleNotesUploadCancel()
    }
  }

  handleMentorFileDescriptionChange(e) {
    this.props.handleNotesDescriptionChange(e)
  }

  onDeleteQuestMentorNoteClick() {
    this.setState(state => ({ mentorNoteExists: false }))
    const note = findQuestMentorNote(this.props.notes, 'Quest')
    this.props.deleteNote(note.id)
  }

  mapList(arr) {
    return arr.map(function (el) {
      return {
        value: el.id,
        label: el.name,
        sort: el.name.trim().toLowerCase()
      }
    })
  }

  handleAuthorChange(values) {
    // Hacky way to format the event id and value so parent's edit function works
    let event = {
      target: {}
    }
    event.target.id = 'ordered_author_ids'
    const idsArray = values.map(a => a.value)
    event.target.value = idsArray
    this.props.handleChange(event)
  }

  handleManagerChange(e) {
    // Hacky way to format the event id and value so parent's edit function works
    let event = {
      target: {}
    }
    event.target.id = 'manager_ids'
    event.target.value = e ? [e.value] : []
    this.props.handleChange(event)
  }

  handleSubjectChange(e) {
    // Hacky way to format the event id and value so parent's edit function works
    let event = {
      target: {}
    }
    event.target.id = 'quest_subject_id'
    event.target.value = e ? e.value : []
    this.props.handleChange(event)
  }

  handleGroupQuestToggle(e) {
    // Need to format yes/no strings from e.target.value to bool
    let event = { target: {} }
    event.target.id = e.target.id
    event.target.value = e.target.value === 'true'
    this.props.handleChange(event)
  }

  handleGradeLevelChange(values) {
    // Hacky way to format the event id and value so parent's edit function works
    let event = {
      target: {}
    }
    event.target.id = 'grade_level_ids'
    const idsArray = values.map(gl => gl.value)
    event.target.value = idsArray
    this.props.handleChange(event)
  }

  formatGradeLevels(gl) {
    return gl.map(function (el) {
      return {
        value: el.id,
        label: el.name,
        sort: el.sort_order
      }
    })
  }

  formatMockCourses(mc) {
    return mc.map(function (el) {
      return {
        value: el.id,
        id: el.id,
        label: el.name,
        sort: el.name,
        color: el.color,
        style: {
          color: el.color
        }
      }
    })
  }

  async onIntendedCourseChange(value) {
    await this.setState(prevState => {
      return {
        intendedCourse: value,
        intendedLevel: value
          ? prevState.intendedCourse && prevState.intendedCourse.id === value.id
            ? prevState.intendedLevel
            : null
          : null
      }
    })
    // Hacky way to format the event id and value so parent's edit function works
    let event = {
      target: {}
    }
    event.target.id = 'mock_course_id'
    // handling for potentially cleared course
    event.target.value = value ? value.value : null
    this.props.handleChange(event)
    // if changing to a different course, nullify mock_level in parent state handler
    if (!this.state.intendedLevel) {
      this.props.handleChange({
        target: {
          id: 'mock_level_id',
          value: null
        }
      })
    }
  }

  onIntendedLevelChange(value) {
    this.setState(() => {
      return {
        intendedLevel: value
      }
    })

    // Hacky way to format the event id and value so parent's edit function works
    let event = {
      target: {}
    }
    event.target.id = 'mock_level_id'
    event.target.value = value ? value.value : null
    this.props.handleChange(event)
  }

  getCourseLevels(course) {
    return this.props.mockCourses.find(mc => mc.id === course.id).mock_levels
  }

  formatCourse(c) {
    return {
      value: c.id,
      id: c.id,
      label: getTruncatedString({ val: c.name, len: 39 }),
      sort: c.name,
      color: c.color,
      style: {
        color: `#${c.color}`
      }
    }
  }

  formatLevel(l) {
    let labelString = `${l.mastery ? 'Mastery Level' : l.number}: ${l.name}`
    return {
      value: l.id,
      id: l.id,
      sort: l.sort_order,
      label: getTruncatedString({ val: labelString, len: 42 })
    }
  }

  handleContentWarningsChange(val) {
    this.props.handleChange({
      target: {
        id: 'content_warnings',
        value: val
      }
    })
  }
}

BasicInformation.propTypes = {
  notes: PropTypes.array,
  quest: PropTypes.object,
  isEditingQuest: PropTypes.bool,
  handleChange: PropTypes.func,
  handleNotesDescriptionChange: PropTypes.func,
  handleNotesUpload: PropTypes.func,
  deleteNote: PropTypes.func,
  dispatch: PropTypes.func,
  users: PropTypes.array,
  isUploadingNote: PropTypes.bool,
  isDeletingNote: PropTypes.bool,
  subjects: PropTypes.array,
  qdUsers: PropTypes.array,
  gradeLevels: PropTypes.array,
  handleNotesUploadCancel: PropTypes.func,
  error: PropTypes.object,
  mockCourses: PropTypes.array.isRequired,
  questTypes: PropTypes.array,
  questManagerUsers: PropTypes.array,
  organization: PropTypes.object.isRequired
}

BasicInformation.contextTypes = {
  intl: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
  notes: state.quest.notes,
  users: state.users.items,
  isEditingQuest: state.quest.isEditingQuest,
  isUploadingNote: state.quest.isUploadingNote,
  isDeletingNote: state.quest.isDeletingNote,
  subjects: alphabeticalSubjects(state),
  qdUsers: getActiveQdUsers(state),
  gradeLevels: state.gradelevels.items,
  error: state.quest.error ? parseErrors(state.quest.error) : null,
  mockCourses: state.mockcourses.items,
  questTypes: state.questtypes.items,
  questManagerUsers: questManagers(state),
  organization: state.organization
})

export default connect(mapStateToProps)(BasicInformation)
export { BasicInformation as BasicInformationDisconnected } // pure component - used in tests



// WEBPACK FOOTER //
// ./src/components/quest/section/BasicInformation.js